import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaxes = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#f97c7c",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3.54932,
			y: 6.80005,
			width: 8.90149,
			height: 7.51221,
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.61743 14.3123H14.3831",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.61743 6.79993H14.3831",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.58203 9.19458V12",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.41809 9.19458V12",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.61694 6.79997L7.35317 1.05807C7.43768 0.97303 7.5386 0.906043 7.64978 0.861178C7.76097 0.816313 7.88011 0.794506 7.99998 0.797079C8.24047 0.798109 8.47084 0.89393 8.64112 1.06375L14.383 6.79997",
			fill: "currentColor",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.61694 6.79997L7.35317 1.05807C7.43768 0.97303 7.53859 0.906043 7.64978 0.861178C7.76097 0.816313 7.88011 0.794506 7.99998 0.797079C8.24047 0.798109 8.47084 0.89393 8.64112 1.06375L14.383 6.79997",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTaxes;
